var TIMEOUT = 500;
var SWIPE_VELOCITY = 0.4;
var MARKER_HEIGHT = 24;
var CLOSE_OFFSET = 0.2;
var SCROLL_OFFSET = 1;
var HEADER_OFFSET = 24;
var convertPercentToNumber = function (value, fullHeight, headerOffset) {
    if (headerOffset === void 0) { headerOffset = HEADER_OFFSET; }
    var maxHeight = fullHeight - headerOffset;
    if (typeof value === 'string') {
        var percent = parseFloat(value) / 100;
        if (percent < 0) {
            return Math.min(maxHeight, fullHeight + fullHeight * percent);
        }
        return Math.min(maxHeight, fullHeight * percent);
    }
    if (value < 0) {
        return Math.max(0, fullHeight + value);
    }
    return Math.min(maxHeight, value);
};

export { CLOSE_OFFSET, HEADER_OFFSET, MARKER_HEIGHT, SCROLL_OFFSET, SWIPE_VELOCITY, TIMEOUT, convertPercentToNumber };
